import { useEffect, useState } from 'react'
import { useRouter } from '../../hooks/router'

import Loading from '../../components/Loading/Loading'
import Channels from '../Channels/Channels'
import Player from '../player/LivePlayer'
import ProgramGuide from '../Epg/ProgramGuide'
import EpgInfo from '../EpgInfo/EpgInfo'

import { get_profile } from '../../server/requests'

import './HomeLive.scss'


export default ({
    showLoading,
    listChannels,
    allChannels,
    favourites,
    setResultSearch,
    appSettings,
    configs,
    isGuest
}) => {

    const router = useRouter()

    const [activeChannelId, setActiveChannelId] = useState(null)
    const [epg, setEpg] = useState()
    const [selectedDay, setSelectedDay] = useState(0)
    const [archive, setArchive] = useState('')


    useEffect(() => {

        if (router.query.id != activeChannelId) setActiveChannelId(router.query.id)

    }, [router.query.id]);

    useEffect(() => {
        console.log(appSettings, 'data categories')
        if (appSettings && appSettings.required_tariff) {
            get_profile({}, res => {
                console.log(res, 'res user')

                if (!res.tariffId) {
                    router.push('/settings?a=payment')
                }
            }, err => { })

        }
    }, [])

    const select_day_epg_live = (e) => {

    }

    const callBackArchive = (el) => {
        setArchive(el)
    }

    return (

        <div className="container">
            <div className="main_live_page">

                {
                    showLoading ?
                        <Loading />
                        :
                        <>
                            <div className="main_channels_live">
                                <Channels
                                    setResultSearch={setResultSearch}
                                    categories={listChannels}
                                    activeChannelId={activeChannelId}
                                    favourites={favourites}
                                />
                            </div>
                            <div className="main_epg_list_live">
                                <ProgramGuide
                                    select_day_epg_live={select_day_epg_live}
                                    setEpg={setEpg}
                                    listChannels={listChannels}
                                    activeChannelId={activeChannelId}
                                    allChannels={allChannels}
                                    callBackArchive={callBackArchive}
                                />
                            </div>
                            <div className="main_player_live">
                                <Player archive={archive} isGuest={isGuest} configs={configs} />
                            </div>
                            <div className="epg_info_live">
                                <EpgInfo epg={epg} activeChannelId={activeChannelId} listChannels={listChannels} />
                            </div>
                        </>
                }
            </div>
        </div>

    )

}